module.exports = __webpack_public_path__ + "static/img/Jackson-Irvine.4986434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jackson-Irvine.jpg
// module id = sGNI
// module chunks = 0